// extracted by mini-css-extract-plugin
export default {"arrow":"absences_arrow__uQsM2","tabs":"absences_tabs__MUBq-","content":"absences_content__qlXep"};